import { USER_MANAGEMENT_DOMAIN } from "../utils/constants";
import usePermission from "./usePermission";
import { acl } from "./userAccessConstant";

const helperMethods: any = {};

helperMethods.isUserManagemnt = () => {
  const hostname: string = window.location.hostname || "";
  const userManagementDomainName: string = USER_MANAGEMENT_DOMAIN || "";
  if (!hostname) {
    return false;
  }

  // Check if it's a subdomain (e.g., length > 2 for "sub.domain.com")
  if (userManagementDomainName && hostname.search(userManagementDomainName) !== -1) {
    return true;
  }

  return false; // No subdomain found
};

helperMethods.userNavigationTabAccess = (permissions:any) => {
  const permissionsMap:{[key:string]:boolean} = {};

  for(let mainModule in acl){
    permissionsMap[mainModule] = permissions[mainModule]?.module?.canRead || false;
  }

  return permissionsMap;
};

export default helperMethods;
